import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-show-image-popup',
  templateUrl: './show-image-popup.component.html',
  styleUrls: ['./show-image-popup.component.scss'],
})
export class ShowImagePopupComponent  implements OnInit {
  image:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<ShowImagePopupComponent>) { }

  ngOnInit() {
    this.image = this.data?.img
  }
  closeDialog(){
    this.dialogRef.close();
  }
}
